module.exports = "<nav style=\"display: none;\">\n  <a routerLink=\"\" routerLinkActive=\"active\">Geoportal</a>\n</nav>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1